const membersOnly = {

	/**
	 * Template to use to push people to sign up.
	 *
	 * @type {string}
	 */
	TEMPLATE: `<div class="p4 b-br2 bg-yellow f4">
	This content is for premium members. <a href="/join/">Become a member</a> or <a href="#/ms/login/" class="login-prompt">Login</a> to get full access.</div>`,


	/**
	 * Template to refresh the page.
	 *
	 * @type {string}
	 */
	TEMPLATE_REFRESH: `<div class="p4 b-br2 bg-yellow f4">
	Logged in. Refresh the page to update the content.</div>`,


	/**
	 * Initialise members only content.
	 */
	init: function() {

		// membersOnly.setLoading();

		/**
		 * Only check the content once we know if the user is logged in or not.
		 */
		document.addEventListener(
			'login-status-change',
			() => {
				console.log( 'login status change' );
				membersOnly.checkContent();
				membersOnly.hideAds();
			}
		);

		const containers = membersOnly.getContainers();
		containers.forEach(
			( e ) => {
				e.addEventListener(
					'click',
					membersOnly.clickEvent
				);
			}
		);

	},


	/**
	 * Set the loading bar.
	 *
	 * @return {void}
	 */
	setLoading: function() {

		const containers = membersOnly.getContainers();

		containers.forEach(
			( e ) => { e.classList.add( 'loading' ); }
		);

	},


	/**
	 * Container click event.
	 *
	 * @param {event} e The event properties.
	 * @return {void}
	 */
	clickEvent: function( e ) {

		if ( e.target.classList.contains( 'login-prompt' ) ) {

			e.preventDefault();
			e.stopPropagation();
			loginform.display();
			return;

		}

	},


	/**
	 * Check if the content can be hidden or not.
	 *
	 * @return {void}
	 */
	checkContent: function() {

		if ( ninja_props && true === ninja_props.members ) {
			if ( !members.isSubscriber() ) {
				membersOnly.hideContent();
			}
		}

		membersOnly.showContainers();

	},


	/**
	 * Hide page content if the container exists.
	 *
	 * @return {void}
	 */
	hideContent: function() {

		const containers = membersOnly.getContainers();

		containers.forEach(
			( e ) => { e.innerHTML = membersOnly.TEMPLATE; }
		);

	},


	/**
	 * Containers are hidden when the page.members is true. This will show them
	 * again.
	 * They are hidden to prevent a flash of content if the javascript has yet
	 * to execute (which is likely).
	 * The content is hidden using css in _includes/script-vars.html
	 *
	 * @return  {void}
	 */
	showContainers: function() {

		const containers = membersOnly.getContainers();

		containers.forEach(
			( e ) => {
				e.classList.add( 'display-block' );
			}
		);

	},


	/**
	 * Get a list of content containers.
	 *
	 * @return {object}
	 */
	getContainers: function() {

		return document.querySelectorAll( '.container' );

	},


	/**
	 * Hide ads for logged in members.
	 *
	 * @return {void}
	 */
	hideAds: function() {

		if ( !members.isSubscriber() ) {
			return;
		}

		const $adWrappers = document.querySelectorAll( '.as-wrapper' );

		if ( !$adWrappers ) {
			return;
		}

		$adWrappers.forEach(
			( e ) => {
				e.innerHTML = '';
			}
		);

	},

};
